import * as types from '../../constants/index'
export default {
  state: {
    cssStyle: 'normal'
  },
  mutations: {
    [types.TOGGLE_PLAYER_AND_PPT] (state, payload) {
      state.cssStyle = payload
    }
  },
  getters: {
    cssStyle: state => state.cssStyle
  }
}
